<template>
  <div class="panel panel-default panel-dashboard">
    <LoadingSpinner v-if="loading"/>

    <div v-else class="panel-body text-center">
      <div class="row">
        <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
          <p style="font-size: 36px; margin-bottom: 0">
            {{ data[0].topic_render_count | number }}
          </p>

          <p style="margin-bottom: 0">
            Topic Page Views
          </p>
        </div>

        <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
          <p style="font-size: 36px; margin-bottom: 0">
            {{ data[0].topic_impression_count | number }}
          </p>

          <p style="margin-bottom: 0">
            Topic Impressions
          </p>
        </div>

        <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
          <p style="font-size: 36px; margin-bottom: 0">
            {{ topic.attributes.content_articles.length | number }}
          </p>

          <p style="margin-bottom: 0">
            Articles
          </p>
        </div>

        <div class="col-xs-6">
          <p style="font-size: 36px; margin-bottom: 0">
            {{ companyCount | number }}
          </p>

          <p style="margin-bottom: 0">
            Companies
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
  components: {LoadingSpinner},

  props: {
    topic: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      data: null,
      loading: true,
    }
  },

  mounted() {
    this.load()
  },

  computed:{
    companyCount() {
      return this.topic.attributes.content_articles.reduce((result, contentArticle) => {
        if(result.includes(contentArticle.portal_company_id)){
          return result
        }

        result.push(contentArticle.portal_company_id)

        return result
      }, []).length
    }
  },

  methods: {
    load() {
      http.post('/api/v1/reports/new-analytics', {
        metrics: [
          {name: 'topic_render_count'},
          {name: 'topic_impression_count'},
        ],
        filters: [
          {dimension: 'routable_id', operator: '=', value: this.topic.id},
        ]
      }).then(response => {
        this.data = response.data.data

        this.loading = false
      })
    },
  }
}
</script>
